import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CodeEditorData, ArtifactType, AutoSavingStatus } from 'src/types';
import { RootState } from '../index';

export interface EditorState {
  editorType: ArtifactType | null;
  codeEditorData: null | CodeEditorData;
  isWordWrapEnabled: boolean;
  isEditorDarkTheme: boolean;
  isEditorStreaming: boolean;
  autoSavingStatus: AutoSavingStatus | null;
}

const initialState: EditorState = {
  editorType: null,
  codeEditorData: null,
  isWordWrapEnabled: true,
  isEditorDarkTheme: false,
  isEditorStreaming: false,
  autoSavingStatus: null,
} as EditorState;

export const editorSlice = createSlice({
  name: 'editor',
  initialState,
  reducers: {
    setEditorType: (state, { payload }: PayloadAction<ArtifactType | null>) => {
      state.editorType = payload;
    },
    setCodeEditorData: (
      state,
      { payload }: PayloadAction<CodeEditorData | null>,
    ) => {
      state.codeEditorData = payload
        ? {
            ...state.codeEditorData,
            ...payload,
          }
        : null;
    },
    setIsWordWrapEnabled: (state, { payload }: PayloadAction<boolean>) => {
      state.isWordWrapEnabled = payload;
    },
    setEditorIsDarkTheme: (state, { payload }: PayloadAction<boolean>) => {
      state.isEditorDarkTheme = payload;
    },
    setEditorStreaming: (state, { payload }: PayloadAction<boolean>) => {
      state.isEditorStreaming = payload;
    },
    setAutoSavingStatus: (
      state,
      { payload }: PayloadAction<AutoSavingStatus | null>,
    ) => {
      state.autoSavingStatus = payload;
    },
  },
});

export const editorState = (state: RootState) => state.editor as EditorState;

export const {
  setEditorType,
  setCodeEditorData,
  setIsWordWrapEnabled,
  setEditorIsDarkTheme,
  setEditorStreaming,
  setAutoSavingStatus,
} = editorSlice.actions;

export default editorSlice.reducer;
